import { company_name } from "@/i18n/variables";

const inputs = {
	account_type: {
		label: "Selecteer uw type account",
		values: {
			business: "Zakelijk",
			private: "Particulier",
		},
	},
	address: {
		label: "Adres",
		placeholder: "Bijvoorbeeld Darwinstraat 29D",
	},
	categories: {
		label: "Labels",
	},
	city: {
		label: "Woonplaats",
		placeholder: "Bijvoorbeeld Ede",
	},
	city_of_birth: {
		label: "Geboorteplaats",
		placeholder: "Bijvoorbeeld Ede",
	},
	coc_number: {
		label: "KVK-nummer",
		placeholder: "Bijvoorbeeld 74698818",
	},
	company_name: {
		label: "Bedrijfsnaam",
		placeholder: `Bijvoorbeeld ${company_name}`,
	},
	company_number: {
		label: "-nummer",
		placeholder: "-nummer",
	},
	country: {
		label: "Land",
		placeholder: "Bijvoorbeeld Nederland",
	},
	country_of_birth: {
		label: "Geboorteland",
		placeholder: "Geboorteland",
	},
	country_select: {
		label: "Selecteer uw land van herkomst",
	},
	created_at: {
		label: "Toegevoegd op",
	},
	date_of_birth: {
		label: "Geboortedatum",
	},
	department: {
		label: "Naam afdeling",
		placeholder: "Bijvoorbeeld inkoop",
	},
	description: {
		label: "Omschrijving",
		placeholder: "Omschrijving",
	},
	email_address: {
		label: "E-mailadres",
		placeholder: `Bijvoorbeeld info@${company_name}.nl`,
	},
	email_address_billing: {
		info: "Naar dit adres worden uw facturen verstuurd.",
		label: "Facturatie e-mailadres",
		placeholder: `Bijvoorbeeld administratie@${company_name}.nl`,
	},
	email_address_reminders_and_warnings: {
		info: "Naar dit adres worden uw facturen verstuurd.",
		label: "Afwijkend e-mailadres voor herinneringen en aanmaningen",
		placeholder: `Bijvoorbeeld administratie@${company_name}.nl`,
	},
	family_name: {
		label: "Achternaam",
		placeholder: "Bijvoorbeeld Janssen",
	},
	given_name: {
		label: "Voornaam",
		placeholder: "Bijvoorbeeld Henk",
	},
	house_number: {
		label: "Huisnummer",
		placeholder: "Bijvoorbeeld 29",
	},
	house_number_appendix: {
		label: "Toevoeging",
		placeholder: "Bijvoorbeeld D",
	},
	house_number_with_appendix: {
		label: "Huisnummer en toevoeging",
		placeholder: "Bijvoorbeeld 29",
	},
	identification_issue_date: {
		label: "Uitgiftedatum identiteitsbewijs",
	},
	identification_issuer: {
		label: "Uitgevende instantie identiteitsbewijs",
		placeholder: "Bijvoorbeeld burgermeester van Ede",
	},
	identification_number: {
		label: "Nummer identiteitsbewijs",
		placeholder: "Bijvoorbeeld 12356789",
	},
	ip_address: {
		label: "IP-adres",
	},
	language: {
		label: "Taal",
		label_alt: "Communicatie taal",
		language_list: {
			de: "Duits",
			en: "Engels",
			nl: "Nederlands",
		},
	},
	last_login: {
		label: "Laatst ingelogd op",
	},
	membership_type: {
		label: "Account type",
		values: {
			business: "Zakelijk",
			private: "Particulier",
		},
	},
	middle_name: {
		label: "Tussenvoegsel",
		placeholder: "Bijvoorbeeld van der",
	},
	name: {
		label: "Naam",
	},
	otp: {
		label: "Geef uw 2FA-code op",
		placeholder: "Bijvoorbeeld 129432",
	},
	password: {
		label: "Wachtwoord",
		placeholder: "Gebruik minimaal 12 tekens, inclusief cijfers, letters en symbolen",
	},
	password_current: {
		label: "Huidig wachtwoord",
		placeholder: "Uw huidige wachtwoord",
	},
	password_new: {
		label: "Nieuw wachtwoord",
		placeholder: "Gebruik minimaal 12 tekens, inclusief cijfers, letters en symbolen",
	},
	password_new_repeat: {
		label: "Herhaal nieuw wachtwoord",
		placeholder: "Herhaal uw nieuwe wachtwoord",
	},
	password_repeat: {
		label: "Herhaal wachtwoord",
		placeholder: "Herhaal uw wachtwoord",
	},
	phone_number: {
		duplicate_dial_code:
			'Let op: Het land dat u oorspronkelijk geselecteerd heeft kan afwijken omdat meerdere landen de landcode "{{dial_code}}" gebruiken. Dit heeft geen invloed op het opgeslagen telefoonnummer.',
		info: "Op dit nummer bellen wij u bij vragen rondom de facturen.",
		label: "Telefoonnummer",
		placeholder: "Bijvoorbeeld 6 1234 5678",
	},
	private_network_description: {
		label: "Omschrijving",
		placeholder: "Omschrijving van uw private network",
	},
	private_network_name: {
		label: "Naam",
		placeholder: "Naam van uw private network",
	},
	province: {
		label: "Provincie",
		placeholder: "Bijvoorbeeld Gelderland",
	},
	relation_autocomplete: {
		add_new: "Nieuwe relatie toevoegen",
		label: "Relatie selecteren",
		placeholder: "Selecteer of maak een nieuwe relatie aan",
	},
	salutation: {
		label: "Aanhef",
		values: {
			d: "Afdeling",
			department: "Afdeling",
			f: "Mevrouw",
			female: "Mevrouw",
			m: "De Heer",
			male: "De Heer",
		},
	},
	street_name: {
		label: "Straatnaam",
		placeholder: "Bijvoorbeeld Darwinstraat",
	},
	trademark_country: {
		label: "Trademark land",
		placeholder: "Trademark land",
	},
	trademark_name: {
		label: "Trademark naam",
		placeholder: "Trademark naam",
	},
	trademark_number: {
		label: "Trademark nummer",
		placeholder: "Trademark nummer",
	},
	user_select: {
		label: "Gebruiker",
		placeholder: "Selecteer een gebruiker",
	},
	username: {
		label: "Gebruikersnaam",
		new_user_placeholder: "Bijvoorbeeld jaap",
		placeholder: "Bijvoorbeeld jaap@DB0001",
	},
	vat_number: {
		label: "BTW-nummer",
		placeholder: "Bijvoorbeeld NL859996657B01",
	},
	zip_code_of_birth: {
		label: "Postcode geboorteplaats",
		placeholder: "Bijvoorbeeld 6718XR",
	},
	zipcode: {
		label: "Postcode",
		placeholder: "Bijvoorbeeld 6718XR",
	},
};

export default inputs;
